// extracted by mini-css-extract-plugin
export default {"componentContainer":"StudentHome_componentContainer__3uTUB"};